export const IS_LIKED = 'is-liked';
export const LIKE_TEXT = 'like-text';
export const LIKE_BUTTON = 'like-button';
export const REACTION_ICON_PENDING = 'reaction-icon-pending';
export const REACTION_MENU = 'reaction-menu';
export const REACTION_MENU_DATA = 'reaction-menu-data';
export const HAS_REACTION = 'has-reaction';
export const REACTION_PENDING = 'reaction-pending';
export const REACTION_METADATA = 'reaction-metadata';
export const LIKE_METADATA = 'like-metadata';
export const LIKE_LIST_MODAL = 'like-list-modal';
export const EMOTION_LIST_MODAL = 'emotion-list-modal';
export const EMOTION_LIST_MODAL_TABLIST = 'emotion-list-modal-tablist';
export const IS_PENDING = 'is-pending';
//# sourceMappingURL=data-hooks.js.map